import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

import { ACTIVATION_ROOT_ROUTE, ACTIVATION_ROOT_URL } from "app/pages/activation/routing/constants";
import ActivationRoot from "app/pages/activation/routing/RootContainer";
import { PACKAGE_NAME, CONFIG_ID, SECONDARY_BAR_TYPE } from "./constants";

import { alertsConfig } from "./alerts";
import { homeConfig } from "./home";
import { projectPageConfig } from "./project";
import { settingsConfig } from "./settings";
import { benchmarkTrackerConfig } from "./benchmark-tracker/benchmarkTrackerConfig";

export const activationConfig: RouterStateConfig = {
    [ACTIVATION_ROOT_ROUTE]: {
        abstract: true,
        url: ACTIVATION_ROOT_URL,
        component: ActivationRoot,
        parent: "sw",
        packageName: PACKAGE_NAME,
        configId: CONFIG_ID,
        configIdDeps: ["WebAnalysis", "MobileWeb", "MobileWebWorldwide"],
        secondaryBarType: SECONDARY_BAR_TYPE,
        hideFromRecents: true,
    },
    ...homeConfig,
    ...projectPageConfig,
    ...settingsConfig,
    ...benchmarkTrackerConfig,
    ...alertsConfig,
};
